import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { waitFor } from '@core/operators';
import { Observable, concatMap, of } from 'rxjs';

import { AuthService } from '@auth/services';

@Injectable()
export class HttpTimeoutInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // skip error reports / client logs
    if (req.urlWithParams.match('.*/log/(error|client).*')) {
      return next.handle(req);
    }

    // skip specific auth endpoints as they handle errors separately
    if (req.urlWithParams.match('.*/auth/(login|logout|ping|change-facility|change-customer).*')) {
      return next.handle(req);
    }

    // skip background image endpoints
    if (req.urlWithParams.match('.*/image/(login|home)-background-(light|dark)$')) {
      return next.handle(req);
    }

    // skip assets
    if (req.urlWithParams.match('.*/assets/.*')) {
      return next.handle(req);
    }

    if (!this.authService.authenticated) {
      return of(null).pipe(
        waitFor(this.authService.loginEvent$),
        concatMap(() => next.handle(req))
      );
    }

    if (this.authService.sessionTimeout) {
      return of(null).pipe(
        waitFor(this.authService.loginEvent$),
        concatMap(() => next.handle(req))
      );
    }

    return next.handle(req);
  }
}
